import type { LucideIcon } from 'lucide-react';
import { AtSign, CircleDot, Shield, User } from 'lucide-react';

const fieldIcon = (Icon: LucideIcon) => <Icon size={18} strokeWidth={2} />;

export const userFieldIcons = {
  userName: fieldIcon(User),
  email: fieldIcon(AtSign),
  role: fieldIcon(Shield),
  isActive: fieldIcon(CircleDot),
};
